"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.Description = exports.StyledIcon = exports.StyledCard = exports.Wrapper = void 0;
const styles_1 = require("@mui/material/styles");
const card_1 = __importDefault(require("../card"));
const Icon_1 = __importDefault(require("../icon/Icon"));
const button_1 = __importDefault(require("../button"));
exports.Wrapper = (0, styles_1.styled)("div")({
    display: "flex",
    flexWrap: "wrap"
});
exports.StyledCard = (0, styles_1.styled)(card_1.default)(({ onClick }) => ({
    width: "300px",
    padding: "10px",
    margin: "10px",
    height: "160px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    "&:hover": {
        cursor: !!onClick && "pointer"
    }
}));
exports.StyledIcon = (0, styles_1.styled)(Icon_1.default)({
    height: "59px",
    width: "59px"
});
exports.Description = (0, styles_1.styled)("div")({
    textAlign: "center"
});
exports.StyledButton = (0, styles_1.styled)(button_1.default)({
    marginTop: "10px"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RpbGUtbGlzdC9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLG1EQUEyQjtBQUMzQix3REFBZ0M7QUFDaEMsdURBQStCO0FBRWxCLFFBQUEsT0FBTyxHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ25DLE9BQU8sRUFBRSxNQUFNO0lBQ2YsUUFBUSxFQUFFLE1BQU07Q0FDakIsQ0FBQyxDQUFDO0FBRVUsUUFBQSxVQUFVLEdBQUcsSUFBQSxlQUFNLEVBQUMsY0FBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLE9BQU8sRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3ZELEtBQUssRUFBRSxPQUFPO0lBQ2QsT0FBTyxFQUFFLE1BQU07SUFDZixNQUFNLEVBQUUsTUFBTTtJQUNkLE1BQU0sRUFBRSxPQUFPO0lBQ2YsT0FBTyxFQUFFLE1BQU07SUFDZixhQUFhLEVBQUUsUUFBUTtJQUN2QixVQUFVLEVBQUUsUUFBUTtJQUNwQixjQUFjLEVBQUUsY0FBYztJQUM5QixTQUFTLEVBQUU7UUFDVCxNQUFNLEVBQUUsQ0FBQyxDQUFDLE9BQU8sSUFBSSxTQUFTO0tBQy9CO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLFVBQVUsR0FBRyxJQUFBLGVBQU0sRUFBQyxjQUFJLENBQUMsQ0FBQztJQUNyQyxNQUFNLEVBQUUsTUFBTTtJQUNkLEtBQUssRUFBRSxNQUFNO0NBQ2QsQ0FBQyxDQUFDO0FBRVUsUUFBQSxXQUFXLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUM7SUFDdkMsU0FBUyxFQUFFLFFBQVE7Q0FDcEIsQ0FBQyxDQUFDO0FBRVUsUUFBQSxZQUFZLEdBQUcsSUFBQSxlQUFNLEVBQUMsZ0JBQU0sQ0FBQyxDQUFDO0lBQ3pDLFNBQVMsRUFBRSxNQUFNO0NBQ2xCLENBQUMsQ0FBQyJ9